import { styled } from "goober";

export const HeaderTitleStack = styled("div")`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
